import ScoreGraph from './ScoreGraph'
import classes from './Graphs.module.css'
import SubmissionGraph from './SubmissionGraph'
import DistributionGraph from './DistributionGraph'

const Graphs = ({ studentsSubmmissionList }) => {

    return (
        <div className={classes.StatisticCharts}>
            <ScoreGraph studentsSubmmissionList={studentsSubmmissionList}></ScoreGraph>
            <SubmissionGraph studentsSubmmissionList={studentsSubmmissionList}></SubmissionGraph>
            <DistributionGraph studentsSubmmissionList={studentsSubmmissionList}></DistributionGraph>
        </div>
    )
}
export default Graphs